import {
  EXPORT_FILENAME_MAX_LENGTH,
  normalizeExportFilename,
} from "@constructionautomation/backend/convex/lib/exportArtifactNames";

export { EXPORT_FILENAME_MAX_LENGTH, normalizeExportFilename };

// Job names often repeat the tool ("Level 2 FieldPilot"), which the export label already says.
const TOOL_NAMES = /\b(spec|takeoff|field|rev)\s?pilot\b/gi;

function includesIgnoringCase(haystack: string, needle: string) {
  return haystack.toLowerCase().includes(needle.toLowerCase());
}

/**
 * Builds a short, readable export name such as "Baker Mackenzie Lead Time Log". Skips any part
 * another part already contains, so a job named "Oaktree Level 2 Takeoff" isn't repeated, and
 * drops tool names from the job name.
 */
export function buildDefaultExportName({
  projectName,
  jobName,
  label,
}: {
  projectName: string | null | undefined;
  jobName?: string | null;
  label: string;
}): string {
  const project = normalizeExportFilename(projectName ?? "");
  const job = normalizeExportFilename((jobName ?? "").replace(TOOL_NAMES, " "));
  const parts: string[] = [];
  if (project && !(job && includesIgnoringCase(job, project))) parts.push(project);
  if (job && !(project && includesIgnoringCase(project, job))) parts.push(job);
  if (!includesIgnoringCase(parts.join(" "), label)) parts.push(label);
  return normalizeExportFilename(parts.join(" "));
}

/** Appends the extension, e.g. "Baker Mackenzie Submittal Log.csv". */
export function withExportExtension(name: string, extension: string): string {
  const ext = extension.trim().replace(/^\.+/, "").toLowerCase();
  return `${normalizeExportFilename(name) || "Export"}.${ext}`;
}
